import React from "react";

const HeroAboutUs = () => (
  <div className="max-w-4xl mx-auto px-4 py-8">
    {/* Our History Section */}
    <div className="bg-white rounded-xl shadow-md border border-neutral-200 overflow-hidden mb-6">
      <div className="px-6 py-4 border-b border-neutral-200">
        <h2 className="text-lg font-semibold text-neutral-800">Our History</h2>
        <div className="w-12 h-1 bg-blue-500 rounded mt-2"></div>
      </div>
      <div className="p-6 space-y-4">
        <p className="text-lg text-neutral-700 font-medium">
          Michael Gibbons had a vision.
        </p>
        <p className="text-neutral-600 leading-relaxed">
          With over twenty years as a Signing Agent himself, he knew that behind every successful closing
          was a knowledgeable, detail-oriented Signing Agent with the passion to ensure the deal got done.
        </p>
        <p className="text-neutral-600 leading-relaxed">
          His vision was to build a platform that ensured every closing was
          handled by these types of Signing Agents.
        </p>
        <p className="text-neutral-600 leading-relaxed">
          With that vision in mind, Gibbons partnered with an experienced technology expert to build a platform that was designed with security at its foundation while
          focusing on the user experience to enable ease of use.
        </p>
        <p className="text-neutral-600 leading-relaxed">
          That vision became <span className="font-semibold text-blue-600">Pinpoint Field Services</span>, launched out of Omaha, Nebraska in the spring of 2023.
        </p>
      </div>
    </div>

    {/* Today Section */}
    <div className="bg-white rounded-xl shadow-md border border-neutral-200 overflow-hidden mb-6">
      <div className="px-6 py-4 border-b border-neutral-200">
        <h2 className="text-lg font-semibold text-neutral-800">Today</h2>
        <div className="w-12 h-1 bg-blue-500 rounded mt-2"></div>
      </div>
      <div className="p-6 space-y-4">
        <p className="text-neutral-600 leading-relaxed">
          Pinpoint Field Services is proud of its secure and intuitive web portal that allows Escrow Officers to easily connect with our database of over <span className="font-semibold text-neutral-800">8,000 Signing Agents</span> to work together
          to easily manage every closing.
        </p>
        <p className="text-neutral-600 leading-relaxed">
          And we ensure that we work with the best Signing Agents by paying a fair fee and prompt payment.
        </p>
        <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mt-4">
          <p className="text-neutral-700 mb-3">
            But don't just take our word for it, check out what our valued partners have to say:
          </p>
          <a
            href="https://www.google.com/search?q=pinpoint+field+services"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 px-4 rounded-lg transition-colors"
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z" />
            </svg>
            View Google Reviews
          </a>
        </div>
      </div>
    </div>
  </div>
);

export default HeroAboutUs;